<div [formGroup]="form" class="w-full">
    <div class="iv-fieldsets">
        <!-- Attacchi da sostituire -->
        <div>
            <div class="iv-subgroup-title">Attacchi da sostituire (%)</div>
            <div class="iv-rows">
                <div class="iv-row">
                    <label>Telaio</label>
                    <app-segmented-select [options]="opzioniStatoUsura" formControlName="attacchiSostTelaio" palette="percent" [wrap]="true"></app-segmented-select>
                </div>
                <div class="iv-row">
                    <label>Intermedia</label>
                    <app-segmented-select [options]="opzioniStatoUsura" formControlName="attacchiSostIntermedia" palette="percent" [wrap]="true"></app-segmented-select>
                </div>
                <div class="iv-row">
                    <label>Cuore</label>
                    <app-segmented-select [options]="opzioniStatoUsura" formControlName="attacchiSostCuore" palette="percent" [wrap]="true"></app-segmented-select>
                </div>
            </div>
        </div>

        <!-- Bulloneria da serrare -->
        <div>
            <div class="iv-subgroup-title">Bulloneria da serrare (%)</div>
            <div class="iv-rows">
                <div class="iv-row">
                    <label>Telaio</label>
                    <app-segmented-select [options]="opzioniStatoUsura" formControlName="bulloniSostTelaio" palette="percent" [wrap]="true"></app-segmented-select>
                </div>
                <div class="iv-row">
                    <label>Intermedia</label>
                    <app-segmented-select [options]="opzioniStatoUsura" formControlName="bulloniSostIntermedia" palette="percent" [wrap]="true"></app-segmented-select>
                </div>
                <div class="iv-row">
                    <label>Cuore</label>
                    <app-segmented-select [options]="opzioniStatoUsura" formControlName="bulloniSostCuore" palette="percent" [wrap]="true"></app-segmented-select>
                </div>
            </div>
        </div>
    </div>

    <!-- Note attacchi/bulloneria -->
    <div class="mt-4">
        <textarea rows="3" pTextarea formControlName="attBulNote" class="w-full" placeholder="Note attacchi/bulloneria"></textarea>
    </div>
</div>
